<app-header></app-header>
<div id="preloader"></div>
<router-outlet></router-outlet>
<app-footer></app-footer>
